import { render, staticRenderFns } from "./playlists-grid-block.vue?vue&type=template&id=60a4d20c"
import script from "./playlists-grid-block.vue?vue&type=script&lang=js"
export * from "./playlists-grid-block.vue?vue&type=script&lang=js"
import style0 from "./playlists-grid-block.vue?vue&type=style&index=0&id=60a4d20c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports